type UnauthorizedCallback = () => void;
let _onUnauthorized: UnauthorizedCallback | null = null;

export function setOnUnauthorized(cb: UnauthorizedCallback | null): void {
  _onUnauthorized = cb;
}

export function notifyUnauthorized(): void {
  _onUnauthorized?.();
}
